//useHeat.js

import { useQuery } from "@tanstack/react-query";
import { loadDashboard } from "../api/reportApi";

export function useHeat(jobId, enabled) {

    return useQuery({
        queryKey: ["heat", jobId],
        enabled,
        queryFn: () => loadDashboard(jobId)
    });
}